<template>
  <nav class="font-sans sticky top-0 left-0" ref="nav" aria-label="main">
    <div class="menu-bar w-full flex flex-wrap text-white items-center px-2">
      <a :href="homeLink" class="block py-4 px-6 mx-auto md:mx-0">
        <img
          v-if="locale === 'fr'"
          src="../assets/images/logo-fr-bw.png"
          role="presentation"
          class="w-40"
        />
        <img
          v-else
          src="../assets/images/logo-bw.png"
          role="presentation"
          class="w-40"
        />
        <span class="sr-only">{{ $t("i18nHome") }}</span>
      </a>
      <ul
        id="top-menu"
        class="w-full md:w-auto flex items-center md:ml-auto text-center"
        ref="topMenu"
      >
        <li>
          <a
            :href="localeLink"
            class="menu-link ml-auto py-4 px-1 md:px-4 hover:bg-blue-pale hover:text-black focus:bg-blue-pale focus:text-black"
            >{{ $t("i18nOtherLang") }}</a
          >
        </li>
        <li>
          <a
            v-if="locale === 'fr'"
            :href="`${publicPath}Rapport_annuel_d'Inter_Pares_2019-web.pdf`"
            class="menu-link ml-auto py-4 px-2 md:px-6 hover:bg-blue-pale hover:text-black focus:bg-blue-pale focus:text-black"
            >{{ $t("i18nDownload") }}
          </a>
          <a
            v-else
            :href="`${publicPath}Inter_Pares_Annual_Report_2019-web.pdf`"
            class="menu-link ml-auto py-4 px-2 md:px-6 hover:bg-blue-pale hover:text-black focus:bg-blue-pale focus:text-black"
            >{{ $t("i18nDownload") }}
          </a>
        </li>
        <li>
          <a
            :href="donateLink"
            class="menu-link ml-auto py-4 px-2 md:px-6 hover:bg-blue-pale hover:text-black focus:bg-blue-pale focus:text-black"
            >{{ $t("i18nDonate") }}</a
          >
        </li>
        <li class="ml-auto">
          <button
            class="menu-link py-4 px-6 hover:bg-blue-pale hover:text-black focus:bg-blue-pale focus:text-black"
            aria-controls="main-menu-list"
            aria-haspopup="true"
            ref="toggle"
          >
            <span class="sr-only">{{ $t("i18nToggle") }} </span>☰
          </button>
        </li>
      </ul>
    </div>
    <div
      class="menu-sections"
      @mouseenter="sectionMenu.elements.controller.open()"
      @mouseleave="sectionMenu.elements.controller.close()"
      ref="wrapper"
    >
      <ul
        class="absolute text-white bg-transparent"
        ref="sectionMenu"
        id="main-menu-list"
      >
        <li
          v-for="item in items"
          :key="item.id"
          :class="{
            'py-0 flex items-center': true,
            active: current === item.id,
          }"
        >
          <a
            :href="item.link"
            :class="{
              'text-shadow px-3 py-1 pl-6 hover:pl-10 focus:pl-10 flex-grow transition-all duration-500 ease-in-out flex items-center': true,
              'font-bold pl-10': current === item.id,
            }"
            @click="menuClick(item.id)"
          >
            <span v-html="item.name" class="sr-only" />
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import AccessibleMenu from "accessible-menu";

export default {
  name: "Menu",
  data() {
    return {
      current: "none",
      observer: null,
      sectionMenu: null,
      topMenu: null,
      localeLink: process.env.VUE_APP_PUBLIC_PATH_OTHER,
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    items() {
      const items = [];

      for (const index in this.$t("i18nSections")) {
        if (index !== "footer") {
          const div = document.createElement("div");

          div.innerHTML = this.$t(`i18nSections.${index}.title`);

          const item = {
            id: index,
            name: div.innerText,
            link: `#page-${index}`,
            element: document.querySelector(`#page-${index}`),
          };

          items.push(item);
        }
      }

      return items;
    },
    homeLink() {
      const { locale } = this;

      if (locale === "fr") {
        return "https://interpares.ca/fr";
      } else {
        return "https://interpares.ca";
      }
    },
    donateLink() {
      const { locale } = this;

      if (locale === "fr") {
        return "http://donations.interpares.ca/fr/faites-un-don";
      } else {
        return "https://donations.interpares.ca/one-time-donation";
      }
    },
  },
  methods: {
    handleHeadingIntersection(entries) {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          if (entry.target.tagName !== "H1") {
            const element = this.items.find(
              item => item.element === entry.target
            );

            this.current = element.id;
          } else {
            this.current = "none";
          }
        }
      });
    },
    menuClick(id) {
      this.current = id;
      this.show = false;
      this.sectionMenu.elements.controller.close();
    },
  },
  mounted() {
    this.observer = new IntersectionObserver(this.handleHeadingIntersection, {
      rootMargin: "0px",
      threshold: 0,
    });

    this.observer.observe(document.querySelector("h1"));

    this.items.forEach(item => {
      this.observer.observe(item.element);
    });

    const { wrapper, toggle, sectionMenu, topMenu } = this.$refs;

    this.sectionMenu = new AccessibleMenu.DisclosureMenu({
      menuElement: sectionMenu,
      controllerElement: toggle,
      containerElement: wrapper,
    });

    this.topMenu = new AccessibleMenu.DisclosureMenu({
      menuElement: topMenu,
      menuLinkSelector: ".menu-link",
    });
  },
};
</script>

<style lang="scss" scoped>
nav {
  z-index: 100;

  *:focus {
    box-sizing: content-box;
    outline: none;
    outline-offset: none;
    box-shadow: 0 0 0 0.2rem #a6dbf4;
  }

  .menu-sections > .show,
  .menu-bar {
    background-color: rgba(#015093, 0.9);
  }

  @screen md {
    li {
      > a::before {
        content: " ";
        width: 6px;
        height: 2rem;
        transform: rotate(90deg) translateY(1.75rem);
        transition: transform 0.5s ease;
        background-image: url("../assets/images/lead-line.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-origin: content-box;
        background-size: 100%;
      }
    }
  }

  .menu-sections > .show {
    @apply w-full;

    @screen md {
      @apply w-1/3;
    }

    a > span {
      @apply not-sr-only;
    }
  }
}
</style>
